// extracted by mini-css-extract-plugin
export default {"area":"styles_area__MRx+J","area__label":"styles_area__label__-tlca"};